<template>
    <div>
        <el-descriptions class="des-content" title="基本信息"  :column="1" border>

            <el-descriptions-item label="车型">
                {{dataDetail.factory.vehicleTradeName}}
            </el-descriptions-item>
            <el-descriptions-item label="初登日期">
                {{dataDetail.factory.registerDate}}
            </el-descriptions-item>
            <el-descriptions-item label="车牌号" :span="2">
                {{  dataDetail.current.plateNo}}
            </el-descriptions-item>
            	
            <el-descriptions-item label="户籍地" :span="2">
                {{ dataDetail.current.registrationPlace}}
            </el-descriptions-item>

            <el-descriptions-item label="车架号">
                {{dataDetail.factory.vin}}
            </el-descriptions-item>
            <el-descriptions-item label="发动机号">
                {{dataDetail.factory.engineNo}}
            </el-descriptions-item>

        </el-descriptions>

        <el-descriptions title="询残信息"  :column="1" border>

            <el-descriptions-item label="询价开始时间">
                {{  dataDetail.bidStartTime}}
            </el-descriptions-item>
            <el-descriptions-item label="询价截止时间">
                {{dataDetail.bidEndTime}}
            </el-descriptions-item>
            <el-descriptions-item label="车辆型号" :span="2">
                {{  dataDetail.factory.vehicleModel}}
            </el-descriptions-item>
            <el-descriptions-item label="变速箱类型" :span="2">
                {{  dataDetail.factory.gearboxType}}
            </el-descriptions-item>
            <el-descriptions-item label="排量">
                {{dataDetail.factory.vehicleDisplacement}}
            </el-descriptions-item>
            <el-descriptions-item label="暂存地">
                {{dataDetail.vehicleParkingArea}}
            </el-descriptions-item>

        </el-descriptions>

        <el-descriptions title="费用信息"  :column="1" border>
            <el-descriptions-item label="拆解费">
                {{dataDetail.cost.overhaulFee}}
            </el-descriptions-item>
            <el-descriptions-item label="停车费">
                 {{dataDetail.cost.parkingFee}}
            </el-descriptions-item>
            <el-descriptions-item label="施救费">
                 {{dataDetail.cost.salvageFee}}
            </el-descriptions-item>
            <el-descriptions-item label="其他费用">
                 {{dataDetail.cost.otherFee}}
            </el-descriptions-item>
        </el-descriptions>

        
        <el-descriptions title="风险排查"  :column="1" border>
            <el-descriptions-item label="车架号是否损伤">
           
                <el-select class="text-disabled" :disabled="true" v-model="dataDetail.damage.steelSealNumber" placeholder="" clearable>
                    <el-option 
                        v-for="dict in dict.type.sys_yes_no"
                        :key="dict.value"
                        :label="dict.label"
                        :value="dict.value"
                    />
                </el-select> 
            </el-descriptions-item>

            <el-descriptions-item label="是否二手车">
              
                <el-select class="text-disabled" :disabled="true" v-model="dataDetail.current.blnTransfer" placeholder="" clearable>
                    <el-option 
                        v-for="dict in dict.type.sys_yes_no"
                        :key="dict.value"
                        :label="dict.label"
                        :value="dict.value"
                    />
                </el-select> 
            </el-descriptions-item>
            <el-descriptions-item label="所有人性质">
                {{dataDetail.current.ownership}}
            </el-descriptions-item>
            <el-descriptions-item label="使用性质">
                {{dataDetail.current.useCharacter}}
            </el-descriptions-item>
            <el-descriptions-item label="是否抵押">
             
                <el-select class="text-disabled" :disabled="true" v-model="dataDetail.procedure.mortgage" placeholder="" clearable>
                    <el-option 
                        v-for="dict in dict.type.sys_yes_no"
                        :key="dict.value"
                        :label="dict.label"
                        :value="dict.value"
                    />
                </el-select> 
            
            </el-descriptions-item>
            <el-descriptions-item label="有无二次事故">
                 {{dataDetail.current.secondaryAccident}}
            </el-descriptions-item>
            <el-descriptions-item label="是否拆解">

                 <el-select class="text-disabled" :disabled="true" v-model="dataDetail.damage.assemble" placeholder="" clearable>
                    <el-option 
                        v-for="dict in dict.type.sys_yes_no"
                        :key="dict.value"
                        :label="dict.label"
                        :value="dict.value"
                    />
                </el-select> 
            </el-descriptions-item>
        </el-descriptions>
        <el-divider content-position="center">车辆图片</el-divider>
        <!--  -->
     
            <el-image 
                style="width: 100px; height: 100px"
                v-for="urlItem in dataDetail.damage.imgUrls" :key="urlItem" :src="urlItem"
                :preview-src-list="dataDetail.damage.imgUrls">
            </el-image> 
  
        
       
    </div>
</template>

<script>
import {getCaseShareDetail} from '@/api/vehicle/case';
export default {
    name:'ShareDetail',
    dicts:['sys_yes_no'],
    created(){
        const caseId=this.$route.query.caseid;
      
        if(caseId){
            this.handleGetDetail(caseId);
        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm=>{
            if(to.query.caseid!=vm.caseId){
                vm.caseId=to.query.caseid;
                // 通过caseId 获取详情
                vm.handleGetDetail(vm.caseId);
                
            }
        });
    },

    data(){
        return{
            dataDetail:{
                bidStartTime:'',//询价时间(竞价开始)
                bidEndTime:'',//逾期时间(竞价结束)
                        
                vehicleSn:'', //车辆编号
                caseSn:'',//报案号
                vehicleParkingArea:'',//车辆停放地
    
                useCharacter:'',// 车辆使用性质
                vehicleDisplacement:'',//排量
                    
                accidentType:'',//事故类型
                insureAmount:'',//保险金额
                actualAmount:'',//实际金额
                estimatedAmount:'',//估损金额
    
                //出厂信息
                factory:{
                    vin:'',//车架号
                    engineNo:'',//发动机号
                    registerDate:'',//登记(注册)日期
                    vehicleModel:'',//车辆型号(行车证)
                    vehicleTradeName:'',//车型型号；传播名
                    gearboxType:'',// 变速箱类型
                    vehicleDisplacement:'',//汽车排量
                    invoiceValue:'',//发票金额
                },
    
                //当前车辆信息
                current:{
                    plateNo:'',//车牌号
                    blnTransfer:'',//是否过户
                    vehicleKim:'',//公里数
                    issueDate:'',//发证日期
                    passengerCommercial:'',//乘用商用
                    practicalValue:'',//实际价值
                    ownership:'',//所有人性质
                },
                //车损信息
                damage:{
                    engineGood:'',//发动机是否完好
                    vehicleEcu:'',//车身电脑
                    engineEcu:'',//发动机电脑
                    responsibility:'',//责任认定
                    delisting:'',//是否脱审
                    casualties:'',//人员伤害
                    assemble:'',//是否拆解
                    imgUrls:[],//显示的图片列表
                
                },
    
                //保险公司信息
                insurance:{
                    insureCompany:'',// 保险公司
                    insureFiliale:'',// 保险分公司
                    insureBranch:'',// 分支机构
                    surveyorName:'', //定损员姓名
                    surveyorPhone:'',//定损员电话
                },
                // 费用信息
                cost:{
                    overhaulFee:'',//拆检费
                    otherFee:'',//其他费用
                    parkingFee:'',//停车费
                    salvageFee:'',//施救费
                    towingFee:'',//拖车费
                },
    
                //手续信息
                procedure:{
                    mortgage:'',//是否抵押
                    licencePlate:'',//车牌
                    loan:'',//是否有贷款
                    idCardCopy:'',//身份证复印件
                    organizationCodeCertificate:'',//组织机构代码证是否有
                    purchaseTax:'',//购置税本
                    registrationCertificate:'',//登记证书是否有
                    subrogationReceipt:'',//权益转让书
                    vehicleKey:'',//车钥匙
                    vehicleLicense:'',//行驶证
                },
    
                // 委托信息
                entrust:{
                    insuranceCompanyName:'',
                    insuranceCompanyPhone:'',
                    vehicleOwnerName:'',
                    vehicleOwnerPhone:'',
                    remark:'',
                },
                //入库信息
                storage:{
                    commitmentUrl:[],//委托协议
                    registrationUrl:[], //登记证书
                    drivingLicenseUrl:[],//驾驶证
                    identityCardUrl:[], //身份证
                    trafficScreenshotUrl:[],//交管截图
                    policyUrl:[],//保险单，
                    transferUrl:[],//过户视频
                    remark:'',
    
                } 
            }
        }
    },

    methods:{
        //显示素材详情
        handleGetDetail(caseId){
           
            // 获取详情
            getCaseShareDetail(caseId)
            .then(res=>{
                this.dataDetail=res.data;   
                let data=this.dataDetail.damage.imgUrls
                if(!Array.isArray(data)){
                    this.dataDetail.damage.imgUrls=JSON.parse(data);
                } 
            })
            .catch(error=>{
                console.log(error);
            })
        }
    }
}
</script>
<style lang="scss" scoped>

.text-disabled{
    -webkit-text-fill-color: #000502 !important; //修改输入框文字颜色
    // font-size: large;
    // font-weight: bolder;
}

</style>